import {AppResource} from '@milestoneslabs/milestones-js-engine';

export const defaultUserRelations = [
    // 'workspaces',
    // 'workspaces.stages.stageType',
    // 'workspaces.members.user.channels',
    // 'workspaces.propertyInstances',
    // 'workspaces.workspaceType',
    // 'workspaceMemberships',
    // 'channelMembers',
    // 'organizationMemberships',
    // 'workspaceMemberships',
    'avatarFile',
];

export default {

    async setAppLoading({dispatch, commit}, isAppLoading = true) {
        commit('SET_IS_APP_LOADING', isAppLoading);
    },

    async initApp({dispatch, commit, getters}) {
        if (getters.isAppInitializing) {
            return;
        }

        console.log('Initialize the app...');

        commit('SET_IS_APP_LOADING', true);
        commit('SET_IS_APP_INITIALIZING', true);

        dispatch('loadAuthUser');

        commit('SET_IS_APP_INITIALIZING', false);
        commit('SET_IS_APP_INITIALIZED', true);


        console.log('App initialized! :)');

    },

    setAppInit({dispatch, commit}, isAppInitialized = true) {

        if (isAppInitialized) {
            dispatch('initApp');
            return;
        }

        commit('SET_IS_APP_INITIALIZED', isAppInitialized);
    },

    loadAuthUser({dispatch, commit, getters}) {
        const resourceData = {
            uuid: getters.authUser.uuid,
            type: 'user',
            attributes: {
                ...getters.authUser,
            },
        };
        delete resourceData.attributes.uuid;
        commit('SET_AUTH_USER_APP_RESOURCE', AppResource.buildFromData(resourceData, true));
    },
};
